import * as React from "react";
import styled from "styled-components";
import { SimpleTreeItemWrapper, TreeItemComponentProps } from "dnd-kit-sortable-tree";
import type { CategoryNode } from "@iterate/common/types/shared";
import s from "./Category.module.css";
import { CategoryContext } from "./CategoryContext";
import { Menu, Item, useContextMenu } from "react-contexify";
import { FolderOpen, GripVertical } from "lucide-react";
import { useIsoContext } from "src/isoContext";
import { formatWholeCurrency } from "src/utils/currency";

export const Category = React.forwardRef<HTMLDivElement, TreeItemComponentProps<CategoryNode>>(
  function CategoryInner(props, ref) {
    const category = props.item;
    const MENU_ID = `category-${category.id}`;
    const { show } = useContextMenu({ id: MENU_ID });
    const ctx = React.useContext(CategoryContext);
    const { isLarge } = useIsoContext();

    return (
      <>
        <SimpleTreeItemWrapper
          {...props}
          ref={ref}
          showDragHandle={false}
          manualDrag={!isLarge}
          hideCollapseButton
          contentClassName={s.categoryContent}
        >
          <Header
            onContextMenu={(event) => show({ event })}
            onClick={(e) => e.stopPropagation()}
            $isDraggable={isLarge}
          >
            {!isLarge && (
              <GripVertical
                {...props.handleProps}
                size={16}
                stroke="#999"
                style={{ marginLeft: -4, touchAction: "none" }}
              />
            )}
            <Name onClick={() => ctx.editCategory(category)}>{category.name}</Name>
            {category.budget && (
              <Field onClick={() => props.onCollapse?.()}>
                <FieldText>{formatWholeCurrency(category.budget)}</FieldText>
              </Field>
            )}
            {category.children.length > 0 && (
              <Field onClick={() => props.onCollapse?.()}>
                <FolderOpen size={16} />
                <FieldText>{category.children.length}</FieldText>
              </Field>
            )}
            <Add onClick={() => ctx.createChildCategory(category)}>+</Add>
          </Header>
        </SimpleTreeItemWrapper>
        <Menu id={MENU_ID}>
          <Item onClick={() => ctx.deleteCategory(category)}>Delete</Item>
        </Menu>
      </>
    );
  },
);

const Header = styled.div<{ $isDraggable: boolean }>`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  ${({ $isDraggable }) => $isDraggable && `touch-action: none;`}
  gap: 5px;
`;

const Name = styled.div`
  flex-grow: 1;
  opacity: 0.75;
  padding: 10px 10px 10px 0;
  &:hover {
    opacity: 1;
  }
`;

const Field = styled.div`
  opacity: 0.5;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const FieldText = styled.div``;

const Add = styled.div`
  padding: 10px;
`;
